(function module() {
	'use strict';
	var directiveId = 'pnlMatch';
	mySynch.directive(directiveId, ['$parse', function matchDirective($parse) {
		var directive = {
			link: link,
			restrict: 'A',
			require: '?ngModel'
		};

		return directive;

		function link(scope, elem, attrs, ctrl) {
			if (!ctrl || !attrs[directiveId]) {
				return;
			}

			var fieldToMatch = $parse(attrs[directiveId]);

			function getTargetValue() {
				var match = fieldToMatch(scope);

				if (angular.isObject(match) && match.hasOwnProperty('$viewValue')) {
					match = match.$viewValue;
				}

				return match;
			}

			scope.$watch(attrs[directiveId], function watcher() {
				ctrl.$$parseAndValidate();
			});

			ctrl.$validators[directiveId] = function validateMatchesTarget(modelValue, viewValue) {
				var fieldValue = modelValue || viewValue;
				var targetValue = getTargetValue();

				return fieldValue === targetValue;
			};
		}
	}]);
})();
